import { IconButton, styled, Box } from '../../base';
import { TOP_HEADER_HEIGHT } from '../../common';

export const Container = styled('div')(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(3),
    paddingTop: theme.spacing(3),
    height: `calc(100vh - ${TOP_HEADER_HEIGHT}px)`,
}));

export const FiltersContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    marginInlineStart: theme.spacing(9),
    width: '400px',
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
        marginInlineStart: 0,
        width: '280px',
    },
}));

export const JobsGrid = styled('div')(({ theme }) => ({
    display: 'grid',
    gap: theme.spacing(3),
    flex: 1,
    overflowY: 'auto',
    height: `calc(100vh - ${TOP_HEADER_HEIGHT}px)`,
}));

export const MobileFiltersButton = styled(IconButton)(({ theme }) => ({
    position: 'fixed',
    bottom: theme.spacing(2),
    insetInlineStart: theme.spacing(2),
    zIndex: 1000,
}));

export const EmptyStateContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    textAlign: 'center',
    gap: theme.spacing(2),
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
}));
